import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "AddRoleModal",
  tabindex: "-1",
  role: "dialog",
  ref: "addAddRoleModalRef",
  "aria-labelledby": "tooltipmodal",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-12 mb-4" }
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_9 = {
  ref: "submitButton",
  class: "btn btn-primary",
  type: "submit"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "modal-header" }, [
          _createElementVNode("h4", { class: "modal-title" }, "Ajout de rôle"),
          _createElementVNode("button", {
            class: "btn-close py-0",
            type: "button",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", null, "Vous êtes sur le point de compléter de (s) rôle (s) à: " + _toDisplayString($props.selectedUser?.nom) + " " + _toDisplayString($props.selectedUser?.prenom), 1),
          _createVNode(_component_Form, {
            ref: "passForm",
            onSubmit: $setup.addRole,
            "validation-schema": $setup.passSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _cache[1] || (_cache[1] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Rôle "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Multiselect, {
                      modelValue: $setup.roles,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.roles) = $event)),
                      options: $setup.roleOptions,
                      "close-on-select": false,
                      "preserve-search": true,
                      "clear-on-select": false,
                      multiple: true,
                      searchable: true,
                      mode: "tags",
                      placeholder: "Sélectionner le rôle",
                      label: "label",
                      "track-by": "label"
                    }, null, 8, ["modelValue", "options"]),
                    ($setup.showMErr)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Le rôle est obligatoire"))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("button", _hoisted_9, " Envoyer ", 512)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ])
    ])
  ], 512))
}